(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["complete-your-look"] && !Shopify.designMode) return;
  try {
    const completeLookRoots = document.querySelectorAll('[data-complete-your-look-block]');

  completeLookRoots.forEach((root) => {
    const list = root.querySelector('[data-complete-your-look-list]');
    const shouldRandomize = String(root.dataset.randomize).toLowerCase() === 'true';

    if (shouldRandomize && list) {
      const cards = Array.from(list.children);
      for (let i = cards.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [cards[i], cards[j]] = [cards[j], cards[i]];
      }
      cards.forEach((card) => list.appendChild(card));
    }

    if (root.dataset.layoutType !== 'carousel') return;

    const prev = root.querySelector('.complete-your-look__arrow--prev');
    const next = root.querySelector('.complete-your-look__arrow--next');

    if (!list || !prev || !next) return;

    prev.addEventListener('click', () => {
      list.scrollBy({ left: -240, behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      list.scrollBy({ left: 240, behavior: 'smooth' });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
